module.exports = __webpack_public_path__ + "img/eye.fa4ec597.svg";